import React from 'react';
import { TimePicker as MuiTimePicker, TimePickerProps } from '@material-ui/pickers';

const TimePicker = React.forwardRef<HTMLDivElement, TimePickerProps>((props: TimePickerProps, ref) => {
  return <MuiTimePicker {...props} />;
});

export default TimePicker;
